import React, { ReactElement } from 'react';
import ChampFormulaire from '../../Common/ChampFormulaire';

export interface PropsChampThematique {
    ordreAffichage: number;
}

export function ChampsThematique(props: PropsChampThematique): ReactElement {
    return (
        <>
            <ChampFormulaire id="name" titre="Nom" />
            <ChampFormulaire id="description" titre="Description" textarea rows={6} />
            <div hidden={true}>
                <ChampFormulaire id="ordreAffichage" {...props} />
            </div>
        </>
    );
}
